import { env } from '@monorepo/env'

export const createUrl = (route: string, query?: { [key: string]: any }) => {
  return `${env.EXPO_PUBLIC_API_URL}${route}` + (query ? `?${new URLSearchParams(query).toString()}` : '')
}

export const createStreamUrl = (route: string, query?: { [key: string]: any }) => {
  return `${env.EXPO_PUBLIC_STREAM_API_URL}${route}` + (query ? `?${new URLSearchParams(query).toString()}` : '')
}
